import { FC, useMemo } from 'react';

import {
  TitleProps as MantineTitleProps,
  Title as MantineTitle,
  useMantineColorScheme,
  useMantineTheme
} from '@mantine/core';

import { ExtendedCustomColors } from '../../theme/colors';
import { useMergeClassNames } from '../../utils';

import { TitleOverrideClassNames } from './Title.styles';

interface TitleProps extends MantineTitleProps {
  darkColor?: ExtendedCustomColors | 'dimmed' | undefined;
}

const Title: FC<TitleProps> = ({ children, c, darkColor, classNames, ...rest }) => {
  const classes = TitleOverrideClassNames();
  const scheme = useMantineColorScheme();
  const theme = useMantineTheme();
  const textColor = useMemo(() => {
    if (scheme.colorScheme === 'dark') {
      return darkColor ? darkColor : theme.colors.dark[0];
    }
    return c;
  }, [scheme, darkColor]);

  const mergedClassNames = useMergeClassNames({
    classNames: [classes, classNames]
  });

  return (
    <MantineTitle {...rest} classNames={mergedClassNames} c={textColor}>
      {children}
    </MantineTitle>
  );
};

export { Title };
export type { TitleProps };
